import {Component, Inject, OnInit, Optional} from '@angular/core';
import {StoreSelectorsService} from '../../services';
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import {ToastrService} from "ngx-toastr";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {copyTextClipboard, createScenePreviewUrl, TOAST_FASTER} from "../../common";
import {IAppSettingsWrap} from "../../interfaces";

@Component({
    selector: 'app-dialog-code',
    templateUrl: './dialog-code.component.html',
    styleUrls: ['./dialog-code.component.scss']
})
export class DialogCodeComponent extends Compbaser implements OnInit {

    embeddedCode = '';
    isFullFeatures;
    coreAppData: IAppSettingsWrap;
    sceneId = '-1';
    codeTemplateId = '-1';

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) data,
        private storeSelector: StoreSelectorsService,
        private translocoService: TranslocoService,
        private toastr: ToastrService
    ) {
        super();
        this.cod(
            this.storeSelector.getCoreData()
                .subscribe((i_coreData: IAppSettingsWrap) => this.coreAppData = i_coreData)
        );
        this.cod(
            this.storeSelector.isFullFeatures().subscribe((v) => {
                this.isFullFeatures = v;
            })
        );

        this.sceneId = data?.sceneId;
        this.codeTemplateId = data.codeTemplateId;

        // if (data) {
        //     this.m_data = data;
        //     if (this.m_data.scenes) {
        //         this.table = 'player_data';
        //         this.totalSelected = this.m_data.scenes.selected.length;
        //         this.icon = 'control_camera';
        //         this.titleString = this.translocoService.translate('general.moveScenesBetweenAccounts', {}, this.translocoService.getActiveLang());
        //     } else {
        //         this.table = 'resources';
        //         this.totalSelected = this.m_data.resources.selected.length;
        //         this.icon = 'playlist_play';
        //         this.titleString = this.translocoService.translate('general.moveResourcesBetweenAccounts', {}, this.translocoService.getActiveLang());
        //     }
        // }
    }

    ngOnInit(): void {
        this.embeddedCode = this.getEmbeddedHTML();
    }

    createSharedUrl(): string {
        // const sceneId = this.previewSceneId ?? this.selectedSceneId;
        return createScenePreviewUrl(this.coreAppData, null, this.sceneId, this.isFullFeatures);
    }

    copyEmbeddedToClipboard() {
        copyTextClipboard(this.getEmbeddedHTML());
        this.toastr.info(this.translocoService.translate('toast.copiedToClipboard', {}, this.translocoService.getActiveLang()), '', TOAST_FASTER);
    }

    private getEmbeddedHTML(): string {
        switch (this.codeTemplateId) {
            case '1': {
                this.embeddedCode = `        import {Compbaser} from "../../../components/compbaser";
                import {IStationData} from "../../../interfaces";
                import {StationSnapshotComponent} from "../station-snapshot/station-snapshot.component";
                import {actionEnterpriseStationsStatusV1V2tReply} from "../../../store/actions/enterprise.actions";
                import {ofType} from "@ngrx/effects";
                import {ActionsSubject} from "@ngrx/store";
                import {actionStationV1V2Update} from "../../../store/actions/user.actions";
                import {fadeTransition, staggerTransition} from "../../../../libs/basicTransition";

                @Component({
                    selector: 'app-station-live',
                    templateUrl: './station-live.component.html',
                    styleUrls: ['./station-live.component.scss'],
                    animations: [
                        fadeTransition,
                        staggerTransition
                    ]
                })
                export class StationLiveComponent extends Compbaser implements OnInit, OnDestroy {
                    m_loading = true;
                    m_mapReady = false;
                    m_loadingStation = true;
                    m_snapStatus = false;
                    m_waitingOnSnap = false;

                    @ViewChild(StationSnapshotComponent, {static: false}) stationSnapshotComponent: StationSnapshotComponent;

                    constructor(public storeSelector: StoreSelectorsService, @Optional() @Inject(MAT_DIALOG_DATA) data,
                                private appService: AppService,
                                private actionsSubj: ActionsSubject,
                                public cdr: ChangeDetectorRef) {
                        super();
                        this.m_stationData = data.stationData;
                    }
                }`;
                return this.embeddedCode;
            }

            case '2': {
                this.embeddedCode = `        <html> 
                <style>
                    * {
                        padding: 0; margin: 0;
                    }
                    body {
                        background-color : black
                    }
                </style>
                <title>
                    free digital signage for everyone
                </title>
                <head>
                    <meta charset="utf-8">
                </head>
                <body>
                    <h3 style="text-align: center; width: 100%; color: red; font-family: verdana,monospace">
                        static page
                    </h3>
                    <iframe marginwidth="0" align="top" scrolling="no"
                        frameborder="0" hspace="0" vspace="0"
                        style="border: none; width: 100%; height: 100%"
                        frameborder="0"
                        src="${this.createSharedUrl()}"
                        style="border:none;width:100%;height:100%;">
                    </iframe>
                </body>
            </html>
        `;
                return this.embeddedCode;
            }

            case '3': {
                this.embeddedCode = `            // Node.js Express server to receive all player updates
            // Triggered per player that is (1) set to monitored (2) changes its state
            const express = require('express')
            const app = express()
            const port = 3000
            app.all('/foobar', async (req, res) => {
                req.body.forEach((player) => {
                    console.log(new Date() + " " + player.props.station_name);
                    console.log("   > connection: " + player.stat.$.connection);
                });
                // console.log("total players updated " + req.body.length});
                // console.log(JSON.stringify(req.body, null, 2));
                return res.send({status: 'success'});
            })
        `;
                return this.embeddedCode;
            }
        }
    }
}

